import styled from 'styled-components';
import { Div, FlexDiv } from '@shared/components/base/Div';
import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';
import { ColorConstants } from '@shared/constants';


export const Header = styled.header`
    display: flex;
    flex-direction: column;
    @media ${MobileScreen} {
        text-align: center;
    }
`;

export const CampaignsComponentWrapper = styled(FlexDiv)`
    flex-wrap: wrap;
    margin-top: -40px;
    @media ${MobileScreen} {
        justify-content: center;
    }
`;

export const Wrapper = styled(Div)`
    background-color: ${ColorConstants.white};
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 150px 1fr;
    padding: 25px 0;
    @media ${MobileScreen} {
        grid-template-rows: 200px 1fr;
        margin-bottom: 30px;
    }
`;
